import { useState } from 'react'
import Slider from 'react-slick'
import { RichText } from 'prismic-reactjs'
import linkResolver from '../../helpers/linkResolver'
import './slideshowSlick.scss'
import './slideshow.scss'
import dynamic from 'next/dynamic'
const Image = dynamic(() => import('../elements/image'), { ssr: false, loading: () => null })

export default ({ pictures, infinite, allowFullscreen, autoplay = false, full_width = false }) => {
  const [fullscreen, setFullscreen] = useState(false)
  const [clickable, setClickable] = useState(true)
  const settings = {
    arrows: full_width ? false : true,
    dots: full_width ? false : true,
    infinite: infinite === 'true', // we receive the bool as a string, hence this comparison
    speed: 500,
    slidesToShow: 1,
    autoplay: !!autoplay,
    slidesToScroll: 1,
    afterChange: () => setClickable(true),
    beforeChange: () => setClickable(false)
  }
  function toggleFullscreen() {
    if (allowFullscreen === 'true' && clickable) {
      setFullscreen(!fullscreen)
    }
  }
  const inner = (
    <div
      className={`article-slideshow ${fullscreen ? 'fullscreen' : 'regular'} ${
        full_width === 'true' ? 'full-width' : 'windowed'
      }`}
    >
      <div className="close" onClick={toggleFullscreen}>
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21">
          <path fill="none" stroke="#fff" d="M.3535.3534L20.8535 20.8534M.3535 20.8534L20.8535.3534" />
        </svg>
      </div>
      <div className="slider">
        <Slider {...settings}>
          {pictures.map((picture, i) => {
            const d = picture.slideshow_image.dimensions
            return (
              <div key={`slideshow-picture-${i}`} className="item" onClick={toggleFullscreen}>
                <Image
                  className="picture"
                  image={picture.slideshow_image}
                  // style={{ height: `calc(100vw / ${d.width} * ${d.height})` }}
                />
                <div className="caption">{RichText.render(picture.image_description, linkResolver)}</div>
              </div>
            )
          })}
        </Slider>
      </div>
    </div>
  )
  if (full_width) {
    return inner
  }
  return <section>{inner}</section>
}
